/**
 * Что показывает «Отделка» — стены, пол или обивку — решает то, по чему кликнули: стена —
 * отделка стен, пол или комната — покрытие пола, мягкая мебель (диван, кресло) — ткани и
 * кожа обивки. Переключателя нет: на стене пол не выбирают, и наоборот. Пока ничего не
 * выделено, видны стены с подсказкой, куда кликнуть.
 */
import { getCatalogItem, isUpholstered } from "@/shared/catalog";
import { findFloorItem } from "@/shared/plan";
import { useProjectStore } from "@/shared/store";
import { SelectionKind, useEditorStore } from "@/widgets/editor";

export type FinishSurface = "walls" | "floor" | "furniture";

export const useFinishSurface = (): FinishSurface => {
	const selection = useEditorStore((s) => s.selection);
	const layers = useProjectStore((s) => s.project.layers);
	if (selection?.kind === SelectionKind.Room) return "floor";
	if (selection?.kind === SelectionKind.Item) {
		const found = findFloorItem(layers, selection.id);
		if (found && isUpholstered(getCatalogItem(found.item.ref))) return "furniture";
	}
	return "walls";
};
